import React from 'react';

export const CardSkeleton = () => (
  <div className="bg-white/5 border border-white/10 rounded-2xl p-6 animate-pulse">
    <div className="h-4 bg-white/10 rounded w-3/4 mb-4" />
    <div className="h-3 bg-white/10 rounded w-1/2 mb-2" />
    <div className="h-3 bg-white/10 rounded w-2/3" />
  </div>
);

export const ImageCardSkeleton = () => (
  <div className="aspect-video bg-white/5 border border-white/10 rounded-2xl animate-pulse" />
);

export const TextSkeleton = ({ width = 'w-full' }) => (
  <div className={`h-3 bg-white/10 rounded ${width} animate-pulse`} />
);
